import { render, staticRenderFns } from "./IcoPinSlash.vue?vue&type=template&id=b31529ae"
import script from "./IcoPinSlash.vue?vue&type=script&lang=js"
export * from "./IcoPinSlash.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports